<h2 mat-dialog-title id="dialog-title">Druck-Schadenmeldung</h2>
<!--  STEP 1  -->
<div *ngIf="stepOne">
  <div mat-dialog-content *ngIf="!isloading">
    <div class="content breaking-text" *ngIf="elements.length > 0">
      <table mat-table [dataSource]="elements" aria-describedby="dialog-title">
        <ng-container matColumnDef="typ-one">
          <th mat-header-cell *matHeaderCellDef>Typ</th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ row.typeLabel }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nachname-one">
          <th mat-header-cell *matHeaderCellDef>Nachname</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div *ngIf="!row.printOnly">
              <p *ngIf="row.type !== 'VOLLMACH'">{{ row.typeLabel === 'Vollmacht' ? '*****' : row.nachname }}</p>
              <mat-form-field *ngIf="row.type === 'VOLLMACH'" [floatLabel]="'never'">
                <input matInput type="text" [(ngModel)]="row.nachname">
                <mat-placeholder *ngIf="row.nachname" class="esign-placeholder">{{ row.nachname }}</mat-placeholder>
              </mat-form-field>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="vorname-one">
          <th mat-header-cell *matHeaderCellDef>Vorname</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div *ngIf="!row.printOnly">
              <p *ngIf="row.type !== 'VOLLMACH'">{{ row.typeLabel === 'Vollmacht' ? '*****' : row.vorname }}</p>
              <mat-form-field *ngIf="row.type === 'VOLLMACH'" [floatLabel]="'never'">
                <input matInput type="text" [(ngModel)]="row.vorname">
                <mat-placeholder *ngIf="row.vorname" class="esign-placeholder">{{ row.vorname }}</mat-placeholder>
              </mat-form-field>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="email-one">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div *ngIf="!row.printOnly">
              <mat-form-field [floatLabel]="'never'">
                <input #emailInput matInput type="email" [(ngModel)]="row.emailInput" [pattern]="emailPattern"
                       (change)="updateEmail($event, i)" #email="ngModel">
                <mat-placeholder *ngIf="row.email" class="esign-placeholder">{{ row.email }}</mat-placeholder>
                <mat-error *ngIf="email.errors">gültige Email z.B. beispiel&#64;test.at</mat-error>
              </mat-form-field>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="mobil-one">
          <th mat-header-cell *matHeaderCellDef>Mobil</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div *ngIf="!row.printOnly">
              <mat-form-field [floatLabel]="'never'">
                <input #handyInput matInput type="tel" [(ngModel)]="row.handyInput" [pattern]="phonePattern"
                       (change)="updateHandy($event, i)" #phone="ngModel">
                <mat-placeholder class="esign-placeholder">{{ getInputPlaceholder(row.handy) }}</mat-placeholder>
                <mat-error *ngIf="phone.errors">TelNr. Format z.B.+4367612345</mat-error>
              </mat-form-field>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="bearbeiten">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row; let i = index">
            <button *ngIf="!(row && row.typeLabel === 'Vollmacht' || row && row.type === 'VOLLMEDI')" mat-icon-button
                    type="button"
                    matTooltip="Person bearbeiten"
                    matTooltipClass="tooltip-multiline" (click)="openEditKundeDialog(row)">
              <mat-icon>create</mat-icon>
            </button>
            <button *ngIf="row && row.typeLabel === 'Vollmacht'" mat-icon-button type="button"
                    matTooltip="Die Vollmacht muss von jener Person ausgefüllt und unterschrieben werden, welche die Anzeige bei der Behörde getätigt hat."
                    matTooltipClass="tooltip-multiline">
              <mat-icon>error_outline</mat-icon>
            </button>
            <button *ngIf="row && row.type === 'VOLLMEDI'" mat-icon-button type="button"
                    matTooltip="Dieses Dokument steht ausschließlich zum Drucken zur Verfügung und kann nicht elektronisch unterschrieben werden."
                    matTooltipClass="tooltip-multiline">
              <mat-icon>error_outline</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="drucken">
          <th mat-header-cell *matHeaderCellDef>Drucken</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <button mat-raised-button color="accent" (click)="getEsignDocument(row.typeLabel, row.nachname, row.type)">
              Drucken
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsStepOne; sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsStepOne;"></tr>
      </table>
    </div>
    <div class="no-data" *ngIf="elements.length === 0">
      <app-no-data text="Antragsdruck konnte nicht gestartet werden"></app-no-data>
    </div>
  </div>
  <div *ngIf="isloading" class="spinner-container">
    <mat-spinner [diameter]="50" strokeWidth="3"></mat-spinner>
  </div>
  <div mat-dialog-actions class="button-container-one">
    <button mat-raised-button color="accent" [disabled]="isloading" (click)="onWeiterClick()">Weiter</button>
    <button mat-raised-button class="mat-gray-bg" (click)="onAbbrechenClick()">Abbrechen</button>
  </div>
</div>

<!--  STEP 2  -->
<div *ngIf="!stepOne">
  <div mat-dialog-content *ngIf="!isloading">
    <div class="content breaking-text" *ngIf="elements.length > 0">
      <table mat-table [dataSource]="getPageTwoElements()">
        <ng-container matColumnDef="typ">
          <th mat-header-cell *matHeaderCellDef>Typ</th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ row.typeLabel }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nachname">
          <th mat-header-cell *matHeaderCellDef>Nachname</th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ row.nachname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="vorname">
          <th mat-header-cell *matHeaderCellDef>Vorname</th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ row.vorname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <input matInput type="email" disabled="true" [ngModel]="row.emailInput ? row.emailInput : row.email">
          </td>
        </ng-container>
        <ng-container matColumnDef="mobil">
          <th mat-header-cell *matHeaderCellDef>Mobil</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <input matInput type="tel" disabled="true" [ngModel]="row.handyInput ? row.handyInput : row.handy">
          </td>
        </ng-container>
        <ng-container matColumnDef="fernunterschrift">
          <th mat-header-cell *matHeaderCellDef>Fern - unterschrift</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <mat-checkbox
              [disabled]="row.status !== 'N' ||  isVerwerfenLoading || isErstellenLoading || isAktualisierenLoading || isFertigLoading"
              [name]="'fern' + i" [(ngModel)]="row.fernunterschrift"
              (change)="onFernunterschriftChange(row)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="bekommtkopie">
          <th mat-header-cell *matHeaderCellDef>bekommt Kopie</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <mat-checkbox #ccCheckbox
                          [disabled]="row.status !== 'N' || isVerwerfenLoading || isErstellenLoading || isAktualisierenLoading || isFertigLoading"
                          [name]="'kopie' + i" [(ngModel)]="row.cc" (change)="onCCClick(row)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <p *ngIf="row.status === 'A'" class="warning-text">Ausstehend</p>
            <p *ngIf="row.status === 'E'">Erledigt</p>
            <button *ngIf="row.status === 'O' " mat-raised-button color="accent"
                    [disabled]="isVerwerfenLoading || isErstellenLoading || isAktualisierenLoading || isFertigLoading"
                    (click)="onUnterschreibenClick(row)">Unterschreiben
            </button>
            <button *ngIf="row.status === 'N' && (!row.vorname || !row.nachname) && row.type === 'VOLLMACH'"
                    mat-icon-button type="button"
                    matTooltip="Zum Erstellen eines Dokuments für die Vollmacht, müssen Vor- und Nachname angegeben werden."
                    matTooltipClass="tooltip-multiline">
              <mat-icon>error_outline</mat-icon>
            </button>
            <button
              *ngIf="row.status === 'N' && !row.fernunterschrift && !((!row.vorname || !row.nachname) && row.type === 'VOLLMACH')"
              mat-raised-button color="accent"
              [disabled]="isVerwerfenLoading || isErstellenLoading || isAktualisierenLoading || isFertigLoading"
              (click)="onErstellenClick(row, i)">
              <mat-spinner *ngIf="newErstellenIndex === i && isErstellenLoading" [diameter]="30"
                           strokeWidth="3"></mat-spinner>
              <span *ngIf="!isErstellenLoading">Erstellen</span></button>
          </td>
        </ng-container>
        <ng-container matColumnDef="aktion">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row; let i = index">
            <button *ngIf="row.status === 'O' || row.status === 'A'"
                    class="button-verwerfen mat-gray-bg"
                    [disabled]="isVerwerfenLoading || isErstellenLoading || isAktualisierenLoading || isFertigLoading"
                    mat-raised-button
                    (click)="onVerwerfenClick(row, i)">
              <mat-spinner *ngIf="newVerwerfenIndex === i && isVerwerfenLoading"
                           [diameter]="30"
                           strokeWidth="3"></mat-spinner>
              <span *ngIf="!isVerwerfenLoading">Verwerfen</span>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsStepTwo; sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsStepTwo;"></tr>
      </table>
    </div>
    <div class="no-data" *ngIf="elements.length === 0">
      <app-no-data text="Antragsdruck konnte nicht gestartet werden"></app-no-data>
    </div>
  </div>
  <div *ngIf="isloading" class="spinner-container">
    <mat-spinner [diameter]="50" strokeWidth="3"></mat-spinner>
  </div>
  <div mat-dialog-actions class="button-container-two">
    <button class="button-aktualisieren" mat-raised-button color="accent"
            [disabled]="isErstellenLoading || isAktualisierenLoading || isVerwerfenLoading || isFertigLoading || isloading"
            (click)="onAktualisierenClick()">
      <mat-spinner *ngIf="isAktualisierenLoading" [diameter]="30" strokeWidth="3"></mat-spinner>
      <span *ngIf="!isAktualisierenLoading">Aktualisieren</span></button>
    <button class="button-fertig" mat-raised-button color="accent"
            [disabled]="isErstellenLoading || isAktualisierenLoading || isFertigLoading || isVerwerfenLoading || isloading"
            (click)="onFertigClick()">
      <mat-spinner *ngIf="isFertigLoading" [diameter]="30" strokeWidth="3"></mat-spinner>
      <span *ngIf="!isFertigLoading">Fertig</span></button>
  </div>
</div>
